import Banner from "template-store/components/banner/banner";
import { withGenericConfig } from "/contexts/generic-config-context";
import TemplateList from "template-store/components/template-list/template-list";
import CategoriesTiles from "template-store/components/categories-tiles/categories-tiles-component";
import { getMostPopularSolutions, getNewAndNotableSolutions } from "template-store/services/solutions-service";
import { getFeaturedCategories } from "template-store/services/solution-categories-service";
import { MOST_POPULAR_CONTEXT, NEW_AND_NOTEABLE_CONTEXT } from "template-store/constants/template-list-context";
import MobileTemplatesNavigation from "template-store/components/mobile-navigation/mobile-navigation-component";
import { HOME_ID } from "template-store/constants/categories";
import { componentStyles } from "./template-homepage-content.scss";

const TemplateHomePageContent = (props) => {
  const { translate, allSolutions, allCategories, onSearchChange } = props;

  return (
    <div className="template-home-page-content-component">
      <div className="banner-wrapper">
        <Banner
          title={translate("templateCenter.homepage.bannerTitle")}
          description={translate("templateCenter.homepage.bannerDescription")}
          titleTagComponent="h1"
          descriptionTagComponent="h2"
        />
      </div>
      <div className="mobile-navigation-wrapper">
        <MobileTemplatesNavigation
          allCategories={allCategories}
          selectedCategoryId={HOME_ID}
          showSearch="true"
          onSearchChange={onSearchChange}
        />
      </div>
      <div className="featured-categories-wrapper">
        <CategoriesTiles
          categories={getFeaturedCategories(allCategories)}
          title={translate("templateCenter.homepage.featuredCategories")}
        />
      </div>
      <div className="most-popular-wrapper">
        <TemplateList
          solutions={getMostPopularSolutions(allSolutions)}
          title={translate("templateCenter.homepage.mostPopular")}
          context={MOST_POPULAR_CONTEXT}
        />
      </div>
      <div className="new-and-notable-wrapper">
        <TemplateList
          solutions={getNewAndNotableSolutions(allSolutions)}
          title={translate("templateCenter.homepage.newAndNotable")}
          context={NEW_AND_NOTEABLE_CONTEXT}
        />
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default withGenericConfig(TemplateHomePageContent);
